export enum TagsInputSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export interface TagsInputValue {
  text: string;
  id: string;
}
